import { useEffect, useRef } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

// Small, non-interactive map preview centered on a position (used in the
// "Standort setzen" confirmation dialog). No pan / zoom / scroll.
export default function LocationPreviewMap({ lat, lon, accuracy }) {
  const elRef = useRef(null);

  useEffect(() => {
    const map = L.map(elRef.current, {
      center: [lat, lon],
      zoom: 16,
      zoomControl: false,
      attributionControl: false,
      dragging: false,
      scrollWheelZoom: false,
      doubleClickZoom: false,
      touchZoom: false,
      boxZoom: false,
      keyboard: false,
      tap: false,
    });
    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      maxZoom: 19,
    }).addTo(map);
    if (accuracy && accuracy <= 2000) {
      L.circle([lat, lon], {
        radius: accuracy,
        color: "#1a73e8",
        weight: 1,
        opacity: 0.3,
        fillColor: "#1a73e8",
        fillOpacity: 0.12,
        interactive: false,
      }).addTo(map);
    }
    L.marker([lat, lon], {
      icon: L.divIcon({
        html: '<div class="user-dot"></div>',
        className: "user-dot-wrap",
        iconSize: [0, 0],
        iconAnchor: [0, 0],
      }),
      interactive: false,
      keyboard: false,
    }).addTo(map);
    const t = setTimeout(() => map.invalidateSize(), 180);
    return () => {
      clearTimeout(t);
      map.remove();
    };
  }, [lat, lon, accuracy]);

  return (
    <div
      ref={elRef}
      className="h-44 w-full overflow-hidden rounded-xl ring-1 ring-slate-200"
      data-testid="setloc-minimap"
    />
  );
}
